// src/PrivateRoute.js
import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

// Funktion zur Überprüfung der Authentifizierung
const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    const exp = decoded.exp * 1000; // Ablaufzeit in Millisekunden
    if (Date.now() >= exp) {
      localStorage.removeItem('token'); // Token entfernen, wenn es abgelaufen ist
      return false;
    }
    return true;
  } catch (err) {
    localStorage.removeItem('token'); // Token entfernen, wenn es ungültig ist
    return false;
  }
};

// Funktion zur Überprüfung der Benutzerrolle
const hasRole = (role) => {
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    return decoded.role === role;
  } catch (err) {
    return false;
  }
};

// PrivateRoute-Komponente
const PrivateRoute = ({ children, role }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/'); // Zur Login-Seite umleiten, wenn nicht authentifiziert
    }
  }, [navigate]);

  if (!isAuthenticated()) {
    return <Navigate to="/" replace />; // Zur Login-Seite navigieren
  }

  if (role && !hasRole(role)) {
    return <Navigate to="/" replace />; // Zur Login-Seite navigieren, wenn die Rolle nicht passt
  }

  return children; // Wenn authentifiziert und Rolle stimmt, geschützte Komponente rendern
};

export default PrivateRoute;
